import { SearchableFilter } from './searchable-filter'

export type CoElement = {
    count: number
    selected: boolean
}

export type CountriesDict = Record<string, CoElement>

export class CountriesFilters extends SearchableFilter {
    selectedCountries: Set<string>
    id: string
    title: string
    fuseEngine: any
    viewAllVisible: boolean
    searchableFilter: CountriesDict
    searchedFilter: CountriesDict
    searchValue: string
    getSearchableFilter = () =>
        Object.keys(this.searchedFilter).length > 0
            ? this.searchedFilter
            : this.searchableFilter
    isPanelCollapsed: boolean
    selectAllSelected: boolean

    constructor(data?: any) {
        super()

        this.selectedCountries = new Set()
        this.id = 'country'
        this.title = ''
        this.fuseEngine = null
        this.viewAllVisible = true
        this.searchableFilter = data
        this.searchedFilter = data
        this.searchValue = ''
        this.isPanelCollapsed = true
        this.selectAllSelected = false
    }
}
